export type CallInventoryPriceData = {
  stores: (string | undefined)[]
  aggregators: (string | undefined)[]
}

export type Action = 'Inventory' | 'Price' | null

const ACTIONS = {
  INVENTORY: 'Inventory',
  PRICE: 'Price',
} as const

const getSelectedStoreAndAggregators = (
  data: CallInventoryPriceData,
  storeOptions: any[],
  aggregatorOptions?: any[],
) => {
  if (!storeOptions || !aggregatorOptions || !data) {
    return { stores: [], aggregators: [] }
  }

  // filter store to display in modal
  const stores = storeOptions.filter((store) =>
    data.stores.includes(store?.value),
  )

  // filter aggregators to display in modal
  if (data?.aggregators && data?.aggregators?.length > 0) {
    const aggregators = aggregatorOptions.filter(
      (aggregator) => data.aggregators?.includes(aggregator?.value),
    )
    return { stores, aggregators }
  }

  return { stores, aggregators: [] }
}

const getStoreOptions = (stores: any[]) => {
  return stores?.map((store: any) => ({
    label: store.storeName,
    value: store._id,
    disabled: false,
  }))
}

const getAggregatorsOptions = (aggregators: any[]) => {
  return aggregators?.map((aggregator: any) => ({
    label: aggregator.aggregatorName,
    value: aggregator._id,
    disabled: false,
  }))
}

export {
  ACTIONS,
  getSelectedStoreAndAggregators,
  getStoreOptions,
  getAggregatorsOptions,
}
